 <template>
	<div class="csoportkezelese">
	    <v-app id="csoportkezeles">
	    	<v-tabs grow v-model="aktivtab">
	    		<v-tab>
		          Jegyek
		      </v-tab>
		      <v-tab>
		          Adatbevitel
		      </v-tab>

		        <v-tab-item>
		        	<h1>Jegyek</h1>
              <v-tabs grow v-model="jegyekaktivtab">
                <v-tab>
                  Jegyek kategóriánként
                </v-tab>
                <v-tab>
                  Jegyek összegezve
                </v-tab>
                <v-tab-item> <!--jegyek kategóriánként-->
                  <v-select
                    label="Megjelenítendő témakör"
                    :items="csoport.temakorok"
                    item-text="nev"
                    item-value="id"
                    v-model="megjelenitendotemakor"
                  ></v-select>
                    <v-simple-table v-if="aktivtab==0">
                      <template v-slot:default>
                        <thead>
                          <th class="text-center">Tanuló</th>
                          <th class="text-center">Átlag</th>
                          <th class="text-center" v-for="gyakorlat in csoport.gyakorlatok" :key="csoport.gyakorlatok.id" v-if="gyakorlat.temakor==megjelenitendotemakor">
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on }">
                                <span v-on="on">{{gyakorlat.nev}}</span>
                              </template>
                              <span>{{gyakorlat.leiras}}</span>
                            </v-tooltip>
                          </th>
                        </thead>
                        <tbody>
                          <tr v-for="tanulo in csoport.tanulok" :key="csoport.tanulok.id">
                            <td class="text-center"> {{tanulo.nev}} </td>
                            <td class="text-center">{{atlagkalkulalas(tanulo.id,tanulo.nem==0,megjelenitendotemakor)}}</td>
                            <td class="text-center" v-for="gyakorlat in csoport.gyakorlatok" :key="csoport.gyakorlatok.id" v-if="gyakorlat.temakor==megjelenitendotemakor">
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                  <span v-on="on">{{jegykalkulalas(tanulo.id,gyakorlat.id,tanulo.nem==0)[0]}}</span>
                                </template>
                                <span>Elvégzett mennyiség: {{jegykalkulalas(tanulo.id,gyakorlat.id,tanulo.nem==0)[1]}}</span>
                              </v-tooltip>
                            </td>
                          </tr>
                          
                        </tbody>
                      </template>
                    </v-simple-table>
                </v-tab-item> <!--jegyek kategóriánként-->
                <v-tab-item> <!--jegyek összegezve-->
                  <v-simple-table v-if="aktivtab==0">
                    <template v-slot:default>
                      <thead>
                        <th class="text-center">Tanuló</th>
                        <th class="text-center">Átlag</th>
                        <th class="text-center" v-for="gyakorlat in csoport.gyakorlatok" :key="csoport.gyakorlatok.id" >
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <span v-on="on">{{gyakorlat.nev}}</span>
                            </template>
                            <span>{{gyakorlat.leiras}}</span>
                          </v-tooltip>
                        </th>
                      </thead>
                      <tbody>
                        <tr v-for="tanulo in csoport.tanulok" :key="csoport.tanulok.id">
                          <td class="text-center"> {{tanulo.nev}} </td>
                          <td class="text-center">{{atlagkalkulalas(tanulo.id,tanulo.nem==0,"m")}}</td>
                          <td class="text-center" v-for="gyakorlat in csoport.gyakorlatok" :key="csoport.gyakorlatok.id">
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on }">
                                <span v-on="on">{{jegykalkulalas(tanulo.id,gyakorlat.id,tanulo.nem==0)[0]}}</span>
                              </template>
                              <span>Elvégzett mennyiség: {{jegykalkulalas(tanulo.id,gyakorlat.id,tanulo.nem==0)[1]}}</span>
                            </v-tooltip>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-tab-item> <!--jegyek összegezve-->
              </v-tabs> <!--Jegyek-->
  		      </v-tab-item>
		        <v-tab-item> <!--Adatbevitel-->
              <v-tabs grow v-model="adatbevitelaktivtab">
                <v-tab>
                  Tanulók és eredményeik
                </v-tab>
                <v-tab>
                  Témakörök, gyakorlatok
                </v-tab>
                <v-tab-item> <!--Tanulók és eredményeik-->
                  <h1 class="text-center">Tanulók és eredményeik</h1>
                  <v-select
                    label="Megjelenítendő témakör"
                    :items="csoport.temakorok"
                    item-text="nev"
                    item-value="id"
                    v-model="megjelenitendotemakor"
                  ></v-select>
                  <v-simple-table>
                    <template v-slot:default>
                      <thead>
                        <th class="text-center">Tanuló</th>
                        <th class="text-center">Nem</th>
                        <th class="text-center">Törlés</th>
                        <th class="text-center" v-for="gyakorlat in csoport.gyakorlatok" :key="csoport.gyakorlatok.id" v-if="gyakorlat.temakor==megjelenitendotemakor">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <span v-on="on">{{gyakorlat.nev}}</span>
                            </template>
                            <span>{{gyakorlat.leiras}}</span>
                          </v-tooltip>
                        </th>
                      </thead>
                      <tbody>
                        <tr v-for="tanulo in csoport.tanulok" :key="csoport.tanulok.id">
                          <td class="text-center"> {{tanulo.nev}} </td>
                          <td class="text-center" v-if="tanulo.nem==0">Fiú</td>
                          <td class="text-center" v-else>Lány</td>
                          <td class="text-center">
                            <v-btn
                              color="red"
                              @click="tanulotorlese(tanulo.id)"
                            >
                              Törlés
                            </v-btn>
                          </td>
                          <td class="text-center" v-for="gyakorlat in csoport.gyakorlatok" :key="csoport.gyakorlatok.id" v-if="gyakorlat.temakor==megjelenitendotemakor"><v-text-field  v-on:change="elvegzettmennyisegmodositas(tanulo.id,gyakorlat.id,$event)" v-model.lazy="csoport.elvegzettgyakorlatok[elvegzettmennyisegindexletrehozas(tanulo.id,gyakorlat.id)].elvegzettmennyiseg"></v-text-field></td>
                        </tr>
                        <tr>
                          <td :colspan="megjelenitettgyakorlatok+3">
                            <v-container>
                              <v-row>
                                <v-col
                                  cols="12"
                                  md="10"
                                >
                                  <v-text-field
                                    label="Új tanuló"
                                    v-model="ujtanulo"
                                  ></v-text-field>
                                </v-col>
                                <v-col>
                                  <v-switch color="pink" label="Lány" v-model="ujtanulolany"></v-switch>

                                </v-col>
                                <v-col><v-switch color="blue" label="Fiú" v-model="ujtanulofiu"></v-switch></v-col>
                                <v-col
                                  cols="12"
                                  md="2"
                                >
                            <v-btn
                                        color="success"
                                        @click="ujTanulo()"
                                    >
                                        Hozzáadás
                                      </v-btn>
                                </v-col>
                              </v-row>
                            </v-container>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-tab-item> <!--Tanulók és eredményeik-->
                <v-tab-item> <!--gyakorlatok és témakörök-->
                  <h1 class="text-center">Témakörök</h1>
                    <v-simple-table>
                      <template v-slot:default>
                        <thead>
                          <th class="text-center">Témakör</th>
                          <th class="text-center">Törlés</th>
                        </thead>
                        <tbody>
                          <tr v-for="temakor in csoport.temakorok" :key="csoport.temakorok.id">
                            <td class="text-center">{{temakor.nev}}</td>
                            <td class="text-center">
                              <v-btn
                                v-if="temakor.id>-1"
                                color="red"
                                @click="temakortorlese(temakor.id)"
                              >
                                Törlés
                              </v-btn>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="2">
                              <v-row>
                                <v-col
                                  cols="12"
                                  md="10"
                                >
                                  <v-text-field
                                    label="Új témakör"
                                    v-model="ujtemakor"
                                  ></v-text-field>
                                </v-col>
                                <v-col
                                  cols="12"
                                  md="2"
                                >
                                  <v-btn
                                    color="success"
                                    @click="temakorhozzaadasa()"
                                  >
                                    Hozzáadás
                                  </v-btn>
                                </v-col>
                              </v-row>
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  <h1 class="text-center">Gyakorlatok</h1>
                  <v-simple-table ref="gyakorlatok">
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th colspan="4"></th>

                          <th colspan="4" class="text-center">Követelmény</th>
                        </tr>
                        <tr>
                          <th class="text-center">Gyakorlat</th>
                          <th class="text-center">Témakör</th>
                          <th class="text-center">Típus</th>
                          <th class="text-center">Növekvő</th>
                          <th class="text-center">5</th>
                          <th class="text-center">4</th>
                          <th class="text-center">3</th>
                          <th class="text-center">2</th>
                          <th class="text-center">Leírás</th>
                          <th class="text-center">Törlés</th>
                        </tr>

                      </thead>
                      <tbody>
                        <tr v-for="(gyakorlat, index) in csoport.gyakorlatok" v-if="gyakorlat.temakor!=-2" v-bind:key="csoport.gyakorlatok.id">
                          <td class="text-center"> {{gyakorlat.nev}} </td>
                          <td class="text-center">
                            <v-select :items="csoport.temakorok" v-model="csoport.gyakorlatok[index].temakor" label="Témakör" item-text="nev" item-value="id" v-on:change="gyakorlatfrissitese(gyakorlat.id, 'temakor', $event)"></v-select>
                          </td>
                          <td>
                            <v-select :items="tipus" v-model="csoport.gyakorlatok[index].tipus"  label="Típus"
                             v-on:change="gyakorlatfrissitese(gyakorlat.id, 'novekvo', $event)"></v-select>
                          </td>
                          <td>
                            <v-select :items="novcsok"  v-model="csoport.gyakorlatok[index].novekvo"  label="Növekvő"
                             v-on:change="gyakorlatfrissitese(gyakorlat.id, 'novekvo', $event)"></v-select>
                          </td>
                          <td class="text-center">
                            <v-col>
                              <v-row>
                                <v-text-field
                                  label="Követelmény - 5 - Fiú"
                                  prepend-inner-icon="gender-male"
                                  color="blue"
                                  v-on:change="gyakorlatfrissitese(gyakorlat.id, 'fkovetelmeny5', $event)"
                                  v-model="csoport.gyakorlatok[index].fkovetelmeny5"
                                ></v-text-field>
                              </v-row>
                              <v-row>
                                <v-text-field
                                  label="Követelmény - 5 - Lány"
                                  prepend-inner-icon="gender-female"
                                  color="pink"
                                  v-on:change="gyakorlatfrissitese(gyakorlat.id, 'lkovetelmeny5', $event)"
                                  v-model="csoport.gyakorlatok[index].lkovetelmeny5"
                                ></v-text-field>
                              </v-row>
                            </v-col>

                          </td>
                          <td class="text-center">
                            <v-col>
                              <v-row>
                                <v-text-field
                                  label="Követelmény - 4 - Fiú"
                                  prepend-inner-icon="gender-male"
                                  color="blue"
                                  v-on:change="gyakorlatfrissitese(gyakorlat.id, 'fkovetelmeny4', $event)"
                                  v-model="csoport.gyakorlatok[index].fkovetelmeny4"
                                ></v-text-field>
                              </v-row>
                              <v-row>
                                <v-text-field
                                  label="Követelmény - 4 - Lány"
                                  prepend-inner-icon="gender-female"
                                  color="pink"
                                  v-on:change="gyakorlatfrissitese(gyakorlat.id, 'lkovetelmeny4', $event)"
                                  v-model="csoport.gyakorlatok[index].lkovetelmeny4"
                                ></v-text-field>
                              </v-row>
                            </v-col>

                          </td>
                          <td class="text-center">
                            <v-col>
                              <v-row>
                                <v-text-field
                                  label="Követelmény - 3 - Fiú"
                                  prepend-inner-icon="gender-male"
                                  color="blue"
                                  v-on:change="gyakorlatfrissitese(gyakorlat.id, 'fkovetelmeny3', $event)"
                                  v-model="csoport.gyakorlatok[index].fkovetelmeny3"
                                ></v-text-field>
                              </v-row>
                              <v-row>
                                <v-text-field
                                  label="Követelmény - 3 - Lány"
                                  prepend-inner-icon="gender-female"
                                  color="pink"
                                  v-on:change="gyakorlatfrissitese(gyakorlat.id, 'lkovetelmeny3', $event)"
                                  v-model="csoport.gyakorlatok[index].lkovetelmeny3"
                                ></v-text-field>
                              </v-row>
                            </v-col>

                          </td>
                          <td class="text-center">
                            <v-col>
                              <v-row>
                                <v-text-field
                                  label="Követelmény - 2 - Fiú"
                                  prepend-inner-icon="gender-male"
                                  color="blue"
                                  v-on:change="gyakorlatfrissitese(gyakorlat.id, 'fkovetelmeny2', $event)"
                                  v-model="csoport.gyakorlatok[index].fkovetelmeny2"
                                ></v-text-field>
                              </v-row>
                              <v-row>
                                <v-text-field
                                  label="Követelmény - 2 - Lány"
                                  prepend-inner-icon="gender-female"
                                  color="pink"
                                  v-on:change="gyakorlatfrissitese(gyakorlat.id, 'lkovetelmeny2', $event)"
                                  v-model="csoport.gyakorlatok[index].lkovetelmeny2"
                                ></v-text-field>
                              </v-row>
                            </v-col>

                          </td>
                          <td>
                              <v-textarea
                                label="Leírás"
                                auto-grow
                                filled
                                solo
                                v-on:change="gyakorlatfrissitese(gyakorlat.id, 'leiras', $event)"
                                v-model="csoport.gyakorlatok[index].leiras"></v-textarea>
                          </td>
                          <td class='text-center'>
                            <v-btn
                              color="red"
                              @click="gyakorlattorlese(gyakorlat.id,csoport.gyakorlatok.findIndex(gyakorlatK => { return gyakorlatK.id===gyakorlat.id}))"
                            >Törlés</v-btn>
                          </td>
                        </tr>
                        <tr>
                          <td colspan="9"><v-form ref="gyakorlathozzaadasa"
                                  lazy-validation
                            >
                              <v-container>
                                <v-row>
                                  <v-col
                                    align-self="center"
                                    cols="16"
                                    md="2"
                                  >
                                    <v-text-field
                                      v-model="ujgyakorlat.nev"
                                      label="Új gyakorlat neve"
                                      required
                                    ></v-text-field>
                                  </v-col>
                                  <v-col
                                    align-self="center"
                                    cols="16"
                                    md="2"
                                  >
                                    <v-select
                                      :items="csoport.temakorok" label="Témakör" v-model="ujgyakorlat.temakor" item-value="id" item-text="nev"
                                    ></v-select>
                                  </v-col>
                                  <v-col
                                    align-self="center"
                                      cols="16"
                                      md="2"
                                    >
                                  <v-select :items="tipus" label="Típus" v-model="ujgyakorlat.tipus"
                                     ></v-select>
                                  </v-col>
                                  <v-col
                                    align-self="center"
                                    cols="16"
                                    md="2"
                                    >
                                    <v-select label="Növekvő" :items="novcsok" v-model="ujgyakorlat.novekvo"></v-select>
                                    </v-col>
                                    <v-col
                                      cols="16"
                                      md="1"
                                    >
                                    <v-row>
                                      <v-text-field
                                        v-model.number="ujgyakorlat.fkovetelmeny5"
                                        label="Követelmény - 5 - Fiú"
                                        prepend-inner-icon="gender-male"
                                        color="blue"
                                        required
                                      ></v-text-field>
                                    </v-row>
                                    <v-row>
                                      <v-text-field
                                        v-model.number="ujgyakorlat.lkovetelmeny5"
                                        label="Követelmény - 5 - Lány"
                                        prepend-inner-icon="gender-female"
                                        color="pink"
                                        required
                                      ></v-text-field>
                                    </v-row>
                                  </v-col>
                                  <v-col
                                    cols="16"
                                    md="1"
                                  >
                                    <v-row>
                                      <v-text-field
                                        v-model.number="ujgyakorlat.fkovetelmeny4"
                                        label="Követelmény - 4 - Fiú"
                                        prepend-inner-icon="gender-male"
                                        color="blue"
                                        required
                                      ></v-text-field>
                                    </v-row>
                                    <v-row>
                                      <v-text-field
                                        v-model.number="ujgyakorlat.lkovetelmeny4"
                                        label="Követelmény - 4 - Lány"
                                        prepend-inner-icon="gender-female"
                                        color="pink"
                                        required
                                      ></v-text-field>
                                    </v-row>
                                  </v-col>
                                  <v-col
                                    cols="16"
                                    md="1"
                                  >
                                    <v-row>
                                      <v-text-field
                                        v-model.number="ujgyakorlat.fkovetelmeny3"
                                        label="Követelmény - 3 - Fiú"
                                        prepend-inner-icon="gender-male"
                                        color="blue"
                                        required
                                      ></v-text-field>
                                    </v-row>
                                    <v-row>
                                      <v-text-field
                                        v-model.number="ujgyakorlat.lkovetelmeny3"
                                        label="Követelmény - 3 - Lány"
                                        prepend-inner-icon="gender-female"
                                        color="pink"
                                        required
                                      ></v-text-field>
                                    </v-row>
                                  </v-col>
                                  <v-col
                                    cols="16"
                                    md="1"
                                  >
                                    <v-row>
                                      <v-text-field
                                        v-model.number="ujgyakorlat.fkovetelmeny2"
                                        label="Követelmény - 2 - Fiú"
                                        prepend-inner-icon="gender-male"
                                        color="blue"
                                        required
                                      ></v-text-field>
                                    </v-row>
                                    <v-row>
                                      <v-text-field
                                        v-model.number="ujgyakorlat.lkovetelmeny2"
                                        label="Követelmény - 2 - Lány"
                                        prepend-inner-icon="gender-female"
                                        color="pink"
                                        required
                                      ></v-text-field>
                                    </v-row>
                                  </v-col>
                                  <v-col
                                    cols="16"
                                    md="2"
                                  >

                                    <v-textarea
                                      v-model="ujgyakorlat.leiras"
                                      label="Leírás"
                                      auto-grow
                                      filled
                                      solo
                                    ></v-textarea>
                                  </v-col>
                                  <v-col
                                    cols="16"
                                    md="2"
                                  >
                                    <v-btn
                                      color="success"
                                      @click="ujGyakorlat()"
                                    >
                                      Létrehozás
                                    </v-btn>
                                  </v-col>
                              </v-row>
                          </v-container>
                            </v-form></td>

                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                  <h1 class="text-center">Gyakorlat importálása másik csoportból</h1>
                  <v-data-table
    				      :headers="gyakorlatosszekapcsolastablazat.fejlecek"
    				      :items="csoport.osszekapcsolas"
    				      sort-by="nev"
                  group-by="Csoport"
    				      class="elevation-1"
    				      :search="gyakorlatosszekapcsolastablazat.kereses"
                  show-group-by
      				    >
      				      <template v-slot:top>
      				        <v-toolbar flat color="white">
      				        	<v-text-field
      						          v-model="gyakorlatosszekapcsolastablazat.kereses"
      						          label="Keresés"
      						          single-line
      						          hide-details
      						        ></v-text-field>

      				        </v-toolbar>
      				      </template>
      				      <template v-slot:item.id="{item}" @click.prevent>
      				      	<v-checkbox
                          readonly
      				     		    v-model="item.id"
                          @click.stop="osszekapcsolas(item.gyakorlatid)"
      				      	></v-checkbox>
      				      </template>
                    <template v-slot:item.Különbözet="{item}" @click.prevent>
      				      	<v-text-field
                        v-if="item.id"
                        label="Különbözet (%)"
                        v-model="item.Különbözet"
                      >
                      </v-text-field>
      				      </template>
      				    </v-data-table>
                </v-tab-item> <!--gyakorlatok és témakörök-->
              </v-tabs>
		        </v-tab-item> <!--Adatbevitel-->
	    	</v-tabs>

	      <v-snackbar
	        v-model="snackbar.megnyit"
	      >
	        {{ snackbar.szoveg }}
	        <v-btn
	          color="pink"
	          text
	          @click="snackbar.megnyit = false"
	        >
	          Bezár
	        </v-btn>
	      </v-snackbar>
	    </v-app>
	</div>

</template>

<script>
/*import axios from 'axios'
axios.defaults.withCredentials = true*/


     import router from "../router"

export default {
  props: ['id'],
  components: {
  },
  data: function () {
  	return {
      gyakorlatosszekapcsolastablazat: {
        keres:'',
        fejlecek: [
          {
  					text: 'Csoport',
  				  align: 'left',
  				  value: 'Csoport'
  				},
          {
            text: 'Gyakorlat',
            align: 'left',
            value: 'Gyakorlat'
          },
          {
            text: 'Különbözet a két csoport között %',
            align: 'left',
            value: 'Különbözet'
          },
          {
            text: "Összekapcsolva",
            align: "left",
            value: 'id'
          }
        ]
      },
      aktivtab:0,
      adatbevitelaktivtab: 0,
      jegyekaktivtab: 0,
  		csoport: {},
  		novcsok: [{ text: 'Növekvő', value: 1 }, { text: 'Csökkenő', value: 0 }],
  		tipus: [{ text: 'Egyszerű', value: 0 }/*, {text: "Idő", value: 1} */],
  		snackbar: {
  			megnyit: false,
  			szoveg: 'Nem számot adott meg!'
  		},
  		ujgyakorlat: {
  			nev: '',
  			temakor: -1,
  			tipus: 0,
  			novekvo: 0,
  			fkovetelmeny5: 5,
  			fkovetelmeny4: 4,
  			fkovetelmeny3: 3,
  			fkovetelmeny2: 2,
  			lkovetelmeny5: 5,
  			lkovetelmeny4: 4,
  			lkovetelmeny3: 3,
  			lkovetelmeny2: 2,
        leiras:''
  		},
  		ujtanulo: '',
  		ujtanulofiu: Math.random() >= 0.5,
  		ujtemakor: '',
  		megjelenitendotemakor: -1,
  		szerkesztettmezoeredetiszoveg: ''
  	}
  },
  computed: {
	ujtanulolany: {
		get: function(){
			return !this.ujtanulofiu;
		},
		set: function(ujertek){
			this.ujtanulofiu=!ujertek
		},
	},
	megjelenitettgyakorlatok: function(){
		var szamlalo=0;
		for(const gyakorlat of this.csoport.gyakorlatok){
			if(gyakorlat.temakor==this.megjelenitendotemakor){
				szamlalo++;
			}
		}
		return szamlalo;
	}
  },
  methods: {
    osszekapcsolas: function(_gyakorlatid) {
      var _osszekapcsolas = this.csoport.osszekapcsolas.find(({gyakorlatid}) => gyakorlatid == _gyakorlatid);
      if(_osszekapcsolas.id){
        this.axios
          .delete(this.$store.state.backendeleres+'csoportok/osszekapcsolas/'+_osszekapcsolas.id+'/csoport/'+this.id)
          .then((response) =>{
            if(response.data.ok){
              _osszekapcsolas.id=null;
              _osszekapcsolas.Különbözet=null;
              this.csoport.gyakorlatok.splice(this.csoport.gyakorlatok.findIndex(gyakorlat => gyakorlat.id==_gyakorlatid),1)
            }
            if(response.data.bejelentkezve==false){
    						this.kijelentkezes();
    				}
          })
      }
      else{
        this.axios
          .post(this.$store.state.backendeleres+'csoportok/osszekapcsolas/csoport/'+this.id+'/gyakorlat/'+_osszekapcsolas.gyakorlatid+'/kulonbozet/100')
          .then((response) =>{
            if(response.data.ok){
              _osszekapcsolas.id=response.data.id;
              _osszekapcsolas.Különbözet=100;
              this.csoport.gyakorlatok.push({fkovetelmeny2: _osszekapcsolas.fkovetelmeny2, fkovetelmeny3: _osszekapcsolas.fkovetelmeny3, fkovetelmeny4: _osszekapcsolas.fkovetelmeny4, fkovetelmeny5: _osszekapcsolas.fkovetelmeny5, id: _osszekapcsolas.gyakorlatid, leiras: null, lkovetelmeny2: _osszekapcsolas.lkovetelmeny2, lkovetelmeny3: _osszekapcsolas.lkovetelmeny3, lkovetelmeny4: _osszekapcsolas.lkovetelmeny4, lkovetelmeny5: _osszekapcsolas.lkovetelmeny5, nev: _osszekapcsolas.Gyakorlat+" ("+_osszekapcsolas.Csoport+", "+_osszekapcsolas.temakor+")", tipus: _osszekapcsolas.tipus, novekvo: _osszekapcsolas.novekvo, temakor: -2})

            }
            if(response.data.bejelentkezve==false){
    						this.kijelentkezes();
    				}
          })
      }
    },
  	kijelentkezes: function() {
            this.$store.commit('bejelentkezve', false)
            router.push('/bejelentkezes');
            this.$store.commit('admin',false)
  	},
    atlagkalkulalas: function(tanuloid, nem,  kategoria) {
      var atlagosszeg = 0;
      var gyakorlatokszama =0;
      this.csoport.gyakorlatok.forEach((e) => {
        if(kategoria=="m" || e.temakor==kategoria){
          gyakorlatokszama++;
          var jegy = this.jegykalkulalas(tanuloid,e.id,nem)[2]
          atlagosszeg+= jegy;
          if(!jegy){
            gyakorlatokszama--;
          }
        }
      })
      return atlagosszeg/gyakorlatokszama;
    },
  	jegykalkulalas: function (tanuloid, gyakorlatid, fiu) {
  		var gyakorlat = this.csoport.gyakorlatok.find(({ id }) => id === gyakorlatid)
  		var elvegzettmennyiseg = this.csoport.elvegzettgyakorlatok[this.elvegzettmennyisegindexletrehozas(tanuloid,gyakorlatid)].elvegzettmennyiseg;
      if(fiu){
        if(gyakorlat.novekvo==1){
          if(elvegzettmennyiseg>=gyakorlat.fkovetelmeny5){
            return [5, elvegzettmennyiseg, 5];
          }
          else if(elvegzettmennyiseg>=gyakorlat.fkovetelmeny4){
            return [4, elvegzettmennyiseg, 4];
          }
          else if(elvegzettmennyiseg>=gyakorlat.fkovetelmeny3){
            return [3, elvegzettmennyiseg, 3];
          }
          else if(elvegzettmennyiseg>=gyakorlat.fkovetelmeny2){
            return [2, elvegzettmennyiseg, 2];
          }
          else if(elvegzettmennyiseg>0){
            return [1, elvegzettmennyiseg, 1];
          }
          else{
            return ["1 (0-t teljesített!!!!)", elvegzettmennyiseg, 0];
          }
        }
        else{
          if(elvegzettmennyiseg>gyakorlat.fkovetelmeny2){
            return [1, elvegzettmennyiseg, 1];
          }
          else if(elvegzettmennyiseg>gyakorlat.fkovetelmeny3){
            return [2, elvegzettmennyiseg, 2];
          }
          else if(elvegzettmennyiseg>gyakorlat.fkovetelmeny4){
            return [3, elvegzettmennyiseg, 3];
          }
          else if(elvegzettmennyiseg>gyakorlat.fkovetelmeny5){
            return [4, elvegzettmennyiseg, 4];
          }
          else if(elvegzettmennyiseg>0){
            return [5, elvegzettmennyiseg, 5];
          }
          else{
            return ["0-t teljesített.", elvegzettmennyiseg, 0];
          }
        }
      }
      else{
        if(gyakorlat.novekvo==1){
          if(elvegzettmennyiseg>=gyakorlat.lkovetelmeny5){
            return [5, elvegzettmennyiseg];
          }
          else if(elvegzettmennyiseg>=gyakorlat.lkovetelmeny4){
            return [4, elvegzettmennyiseg];
          }
          else if(elvegzettmennyiseg>=gyakorlat.lkovetelmeny3){
            return [3, elvegzettmennyiseg];
          }
          else if(elvegzettmennyiseg>=gyakorlat.lkovetelmeny2){
            return [2, elvegzettmennyiseg];
          }
          else if(elvegzettmennyiseg>0){
            return [1, elvegzettmennyiseg];
          }
          else{
            return ["1 (0-t teljesített!!!!)", elvegzettmennyiseg];
          }
        }
        else{
          if(elvegzettmennyiseg>gyakorlat.lkovetelmeny2){
            return [1, elvegzettmennyiseg];
          }
          else if(elvegzettmennyiseg>gyakorlat.lkovetelmeny3){
            return [2, elvegzettmennyiseg];
          }
          else if(elvegzettmennyiseg>gyakorlat.lkovetelmeny4){
            return [3, elvegzettmennyiseg];
          }
          else if(elvegzettmennyiseg>gyakorlat.lkovetelmeny5){
            return [4, elvegzettmennyiseg];
          }
          else if(elvegzettmennyiseg>0){
            return [5, elvegzettmennyiseg];
          }
          else{
            return ["0-t teljesített.", elvegzettmennyiseg];
          }
        }

      }
  	},
  	temakorhozzaadasa: function () {
  		if (this.ujtemakor != '') {
  			this.axios
  				.post(this.$store.state.backendeleres+'csoportok/csoport/' + this.id + '/temakorok', { nev: this.ujtemakor })
  				.then(response => {
  					if (response.data.ok) {
  						this.csoport.temakorok.push({ id: response.data.id, nev: response.data.nev })
  					}
  					this.ujtemakor = ''
  					if(response.data.bejelentkezve==false){
  						this.kijelentkezes();
  					}
  				})
  		} else {
  			this.snackbar.szoveg = 'Adja meg az új témakör nevét!'
  			this.snackbar.megnyit = true
  		}
  	},
  	temakortorlese: function (temakorid) {
  		this.axios
  			.delete(this.$store.state.backendeleres+'csoportok/temakorok/' + temakorid)
  			.then(response => {
  				if (response.data.ok) {
  					this.csoport.temakorok.splice(this.csoport.temakorok.findIndex(
  							temakor => {
  								return temakor.id == temakorid
  							}
  						), 1)
  					for (var i = 0; i < this.csoport.gyakorlatok.length; i++) {
  						if (this.csoport.gyakorlatok[i].temakor == temakorid) {
  							this.csoport.gyakorlatok[i].temakor = -1
  						}
  					}
  					if (this.megjelenitendotemakor == temakorid) {
  						this.megjelenitendotemakor = -1
  					}
  				}
  				if(response.data.bejelentkezve==false){
  						this.kijelentkezes();
  				}
  			})
  	},
  	tanulotorlese: function (tanuloid) {
  		this.axios
  			.delete(this.$store.state.backendeleres+'csoportok/tanulok/' + tanuloid)
  			.then(response => {
  				if (response.data.ok) {
  					this.csoport.tanulok.splice(this.csoport.tanulok.findIndex(
  							tanulo => {
  								return tanulo.id == tanuloid
  							}
  						), 1)
  				}
  				if(response.data.bejelentkezve==false){
  						this.kijelentkezes();
  				}
  			})
  	},
  	ujTanulo: function () {
  		if (this.ujtanulo != '') {
  			this.axios
  				.post(this.$store.state.backendeleres+'csoportok/csoport/' + this.id + '/tanulok', { nev: this.ujtanulo, fiu: this.ujtanulofiu })
  				.then(response => {
  					if (response.data.ok) {
  						this.csoport.tanulok.push({ id: response.data.id, nev: response.data.nev, nem: response.data.nem})
  					}
  					this.ujtanulo = ''
  					if(response.data.bejelentkezve==false){
  						this.kijelentkezes();
  					}
  				})
  		} else {
  			this.snackbar.szoveg = 'Adja meg az új tanuló nevét!'
  			this.snackbar.megnyit = true
  		}
  	},
  	elvegzettmennyisegindexletrehozas: function(tanulo,gyakorlat) {
  		var index= this.elvegzettmennyisegid(tanulo,gyakorlat);
  		if(index!=-1){
  			return index;
  		}
  		else{
  			this.csoport.elvegzettgyakorlatok.push({id: -1, elvegzettmennyiseg:0, gyakorlatid: gyakorlat, tanuloid: tanulo});
  			/*console.log({id: -1, elvegzettmennyiseg:0, gyakorlatid: gyakorlat, tanuloid: tanulo})
  			console.log(this.csoport.elvegzettgyakorlatok[this.elvegzettmennyisegid(tanulo,gyakorlat)])*/

  			return this.elvegzettmennyisegid(tanulo,gyakorlat);
  		}
  	},
  	elvegzettmennyisegszamitas: function (tanulo, gyakorlat) {
  		var index = this.elvegzettmennyisegid(tanulo, gyakorlat)
	    if (index != -1) {
	    	return this.csoport.elvegzettgyakorlatok[index].elvegzettmennyiseg
	    } else {
	    	return '0'
	    }
  	},
  	elvegzettmennyisegid: function (tanulo, gyakorlat) {
  		var index = this.csoport.elvegzettgyakorlatok.findIndex(elvegzettgyakorlat => {
	              	var tanuloOK = elvegzettgyakorlat.tanuloid == tanulo
	              	var gyakorlatOK = elvegzettgyakorlat.gyakorlatid == gyakorlat
	              	return tanuloOK & gyakorlatOK
	              })
  		return index
  	},
  	elvegzettmennyisegmodositas: function (tanulo, gyakorlat, elvegzettmennyiseg) {
  		var elvegzettmennyisegID = this.elvegzettmennyisegid(tanulo, gyakorlat)
  		if (!isNaN(elvegzettmennyiseg) & elvegzettmennyiseg != '') {
  			if (this.csoport.elvegzettgyakorlatok[elvegzettmennyisegID].id == -1) {
  				this.axios
	  				.post(this.$store.state.backendeleres+'csoportok/elvegzettgyakorlatok/' + gyakorlat + '/tanulo/' + tanulo, { elvegzettmennyiseg: elvegzettmennyiseg })
	  				.then(response => {
	  					if (response.data.ok) {
	  						this.csoport.elvegzettgyakorlatok[elvegzettmennyisegID] = { id: response.data.id, elvegzettmennyiseg: response.data.elvegzettmennyiseg, gyakorlatid: response.data.gyakorlatid, tanuloid: response.data.tanuloid }
	  						this.snackbar.szoveg="Mentve";
	  						this.snackbar.megnyit=true;
	  					}
	  					else{
	  						this.snackbar.szoveg=response.data.hiba
	  						this.snackbar.megnyit=true;
	  					}
	  					if(response.data.bejelentkezve==false){
	  						this.kijelentkezes();
	  					}
	  				})
  			} else {
  				this.axios
  					.put(this.$store.state.backendeleres+'csoportok/elvegzettgyakorlatok/' + gyakorlat + '/tanulo/' + tanulo, { elvegzettmennyiseg: elvegzettmennyiseg })
  					.then(response => {
  						if (response.data.ok) {
  							this.csoport.elvegzettgyakorlatok[elvegzettmennyisegID] = { id: response.data.id, elvegzettmennyiseg: response.data.elvegzettmennyiseg, gyakorlatid: response.data.gyakorlatid, tanuloid: response.data.tanuloid }
  								  						this.snackbar.szoveg="Mentve";
	  						this.snackbar.megnyit=true;

  						}
  						else{
	  						this.snackbar.szoveg=response.data.hiba
	  						this.snackbar.megnyit=true;
	  					}
	  					if(response.data.bejelentkezve==false){
	  						this.kijelentkezes();
	  					}
  					})
  			}
  		} else {
  			this.snackbar.szoveg = 'Nem számot adott meg!'
  			this.snackbar.megnyit = true
  			if(elvegzettmennyisegID != -1){
  				this.axios
	  				.get(this.$store.state.backendeleres+'csoportok/elvegzettgyakorlatok/'+gyakorlat+'/tanulo/'+tanulo)
	  				.then(response => {
	  					this.csoport.elvegzettgyakorlatok[elvegzettmennyisegID].elvegzettmennyiseg = response.data.elvegzettmennyiseg;
	  					if(response.data.bejelentkezve==false){
	  						this.kijelentkezes();
	  					}
	  				})
  			}

  		}
  	},
  	csoportfrissitese: function () {
  		this.axios
  			.get(this.$store.state.backendeleres+'csoportok/csoport/' + this.id)
  			.then(response => {this.csoport = response.data;
  				if(response.data.bejelentkezve==false){
  						this.kijelentkezes();
  					}
					this.csoport.temakorok.push({id: -2, nev: "Összekapcsolt"})
					this.csoport.osszekapcsolas.forEach((elem) =>{
						if(elem.id)
						{

							this.csoport.gyakorlatok.push({fkovetelmeny2: elem.fkovetelmeny2, fkovetelmeny3: elem.fkovetelmeny3, fkovetelmeny4: elem.fkovetelmeny4, fkovetelmeny5: elem.fkovetelmeny5, id: elem.gyakorlatid, leiras: null, lkovetelmeny2: elem.lkovetelmeny2, lkovetelmeny3: elem.lkovetelmeny3, lkovetelmeny4: elem.lkovetelmeny4, lkovetelmeny5: elem.lkovetelmeny5, nev: elem.Gyakorlat+" ("+elem.Csoport+", "+elem.temakor+")", tipus: elem.tipus, novekvo: elem.novekvo, temakor: -2})
						}

					})
  			})
  	},
  	gyakorlatfrissitese: function (gyakorlatid, mezo, esemeny) {
  		var gyakorlat = this.csoport.gyakorlatok.find(({ id }) => id === gyakorlatid)
      var helyesertek=!isNaN(esemeny);
      if(mezo=="leiras"){
        helyesertek=true;
      }
  		if (helyesertek) {
  			var gyakorlatmasolat = this.objektumatadas(gyakorlat)
  			gyakorlatmasolat[mezo] = esemeny
  		this.axios
  			.put(this.$store.state.backendeleres+'csoportok/gyakorlat/' + gyakorlat.id, gyakorlatmasolat)
  			.then(response => {
  				if (response.data.ok) {
  					gyakorlat[mezo] = esemeny
  					this.snackbar.szoveg = 'Mentve'
	  				this.snackbar.megnyit = true
  				} else {
  					this.snackbar.szoveg = response.data.hiba
  					this.snackbar.megnyit = true
  					gyakorlat = response.data.eredetigyakorlat
  				}
  				if(response.data.bejelentkezve==false){
  						this.kijelentkezes();
  					}
  			})
  		} else {
  			this.snackbar.szoveg = 'Nem számot adott meg!'
  			this.snackbar.megnyit = true
  			this.axios
  				.get(this.$store.state.backendeleres+'csoportok/gyakorlat/'+gyakorlatid+'/'+mezo)
  				.then(response => {
  					gyakorlat[mezo]=response.data.mezo;
  					if(response.data.bejelentkezve==false){
  						this.kijelentkezes();
  					}
  				})
  		}
  	},
  	ujGyakorlat: function () {
  		if (this.ujgyakorlat.nev != '' && this.ujgyakorlat.fkovetelmeny5 != '' && !isNaN(this.ujgyakorlat.fkovetelmeny5) && this.ujgyakorlat.fkovetelmeny4 != '' && !isNaN(this.ujgyakorlat.fkovetelmeny4) && this.ujgyakorlat.fkovetelmeny3 != '' && !isNaN(this.ujgyakorlat.fkovetelmeny3) && this.ujgyakorlat.fkovetelmeny2 != '' && !isNaN(this.ujgyakorlat.fkovetelmeny2)) {
  			this.axios
	  			.post(this.$store.state.backendeleres+'csoportok/csoport/' + this.id + '/gyakorlatok', this.ujgyakorlat)
	  			.then(response => {
	  				if (response.data.ok) {
	  					delete response.data.ok
	  					this.csoport.gyakorlatok.push(response.data)
	  					this.ujgyakorlat.nev = ''
              this.ujgyakorlat.leiras=''
	  					this.snackbar.szoveg = 'Mentve'
	  					this.snackbar.megnyit = true
	  				} else {
	  					this.snackbar.szoveg = response.data.hiba
	  					this.snackbar.megnyit = true
	  				}
	  				if(response.data.bejelentkezve==false){
  						this.kijelentkezes();
  					}
	  			})
  		} else {
  			this.snackbar.szoveg = 'Adjon meg minden értéket helyesen!'
  			this.snackbar.megnyit = true
  		}
  	},
  	gyakorlattorlese: function (gyid, tid) {
  		this.axios
  			.delete(this.$store.state.backendeleres+'csoportok/gyakorlatok/' + gyid)
  			.then(response => {
  				if (response.data.ok) {
  					this.csoport.gyakorlatok.splice(tid, 1)
  				}
  				if(response.data.bejelentkezve==false){
  						this.kijelentkezes();
  					}
  			})
  	},
  	objektumatadas: function (objektum) {
  		return JSON.parse(JSON.stringify(objektum))
  	},
  	mezoszerkeszteskezd: function(eredetiertek) {
  		this.szerkesztettmezoeredetiszoveg=eredetiertek;
  	}
  },
  mounted () {
    this.csoportfrissitese()
  }
}
</script>
